import { render } from "./SingleChoice.vue?vue&type=template&id=438c9e81&scoped=true&ts=true"
import script from "./SingleChoice.vue?vue&type=script&lang=ts"
export * from "./SingleChoice.vue?vue&type=script&lang=ts"

import _style_0 from "./SingleChoice.vue?vue&type=style&index=0&id=438c9e81&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-438c9e81"]])

export default __exports__